function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-autreOuvrant");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-autreOuvrant",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,4 C21.0751322,4 26,8.92486775 26,15 C26,21.0751322 21.0751322,26 15,26 C8.92486775,26 4,21.0751322 4,15 C4,8.92486775 8.92486775,4 15,4 Z M15,10 C12.2385763,10 10,12.2385763 10,15 C10,17.7614237 12.2385763,20 15,20 C17.7614237,20 20,17.7614237 20,15 C20,12.2385763 17.7614237,10 15,10 Z",
  id: "Combined-Shape"
})));

const SvgIco30AutreOuvrant = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30AutreOuvrant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-autreOuvrant.49f01268.svg";
export { ForwardRef as ReactComponent };